import { useEffect } from 'react';
import useSocketListeners from './socket/useSocketListeners';

/**
 * Wires the app-wide concerns that have no UI of their own. Registers the socket listeners through useSocketListeners and, for the component's lifetime, a window keydown listener that swallows Ctrl+S.
 *
 * @returns Nothing.
 */
const useApp = () => {
  useSocketListeners();

  useEffect(() => {
    /**
     * Suppresses the browser's native save dialog anywhere in the report app. Calls preventDefault when Ctrl or Cmd is held together with key code 83.
     *
     * @param event - Keydown event delivered by the window listener.
     * @returns Nothing.
     */
    const handleKeyDown = (event: KeyboardEvent) => {
      const { keyCode, ctrlKey, metaKey } = event;
      //* Ctrl + S: Disabled browser default save function for all page
      if ((ctrlKey || metaKey) && keyCode === 83) {
        event.preventDefault();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
};

export default useApp;
